import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as SessionActions from 'web-app/react/entities/sessions/actions';
import * as ProductActions from 'web-app/react/entities/products/actions';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';

const PlanSettingsState = Record({
    institutionId: null,
    sessionBehaviors: new BehaviorsCollection(),
    sessionVersions: List(),
    productBehaviors: new BehaviorsCollection(),
    productVersions: List(),
    showManagePricingGroups: null,
    fetchingProducts: true,
    fetchingSessions: true,
});

export default handleActions(
    {
        [Actions.showingInstitutionId.type]: (state, {payload}) =>
            state.merge({
                showManagePricingGroups: null,
                institutionId: payload.institutionId,
            }),
        [Actions.showManagePricingGroups.type]: (state, {payload}) =>
            state.merge({
                showManagePricingGroups: payload.show,
            }),
        [SessionActions.fetchAll.type]: state =>
            state.merge({
                fetchingSessions: true,
            }),
        [SessionActions.fetchAllSuccess.type]: (state, {payload}) =>
            state.merge({
                fetchingSessions: false,
                sessionBehaviors: payload.behaviors,
                sessionVersions: List(payload.sessions).map(session => session.version),
            }),
        [ProductActions.fetchAll.type]: state =>
            state.merge({
                fetchingProducts: true,
            }),
        [ProductActions.fetchAllSuccess.type]: (state, {payload}) =>
            state.merge({
                fetchingProducts: false,
                productBehaviors: payload.behaviors,
                productVersions: List(payload.products).map(products => products.version),
            }),
    },
    new PlanSettingsState(),
);
